module.exports = __webpack_public_path__ + "themes/mf/font/SignPainter-HouseScript.svg";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/SignPainter-HouseScript.svg
// module id = 134
// module chunks = 3